export default __webpack_public_path__ + "static/media/Savings2.9772be2e.png";